import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChappsCommonAngularLibraryModule, ChappsListModule } from '@npm.chapps.com/chapps.common.angular.library';
import { CommonsModule } from '../../common/common.module';
import { ChecklistsComponent } from './checklists.component';
import { ChecklistListItemComponent } from './components/checklist-list-item/checklist-list-item.component';
import { CreateChecklistModalComponent } from './components/create-checklist-modal/create-checklist-modal.component';
import { ChecklistComponent } from './checklist/checklist.component';
import { AddNodeOrCheckpointModalComponent } from './components/add-node-or-checkpoint-modal/add-node-or-checkpoint-modal.component';
import { AddCustomCheckpointModalComponent } from './components/add-custom-checkpoint-modal/add-custom-checkpoint-modal.component';
import { EditNodeModalComponent } from './components/edit-node-modal/edit-node-modal.component';
import { RenameChecklistModal } from './components/rename-checklist-modal/rename-checklist-modal.component';
import { CopyChecklistModalComponent } from './components/copy-checklist-modal/copy-checklist-modal.component';
import { SelectCheckpointCreationMethodModal } from './components/select-checkpoint-creation-method-modal/select-checkpoint-creation-method-modal.component';
import { AddUpdateCheckpointModalComponent } from './components/add-update-checkpoint-modal/add-update-checkpoint-modal.component';
import { DragDropModule } from "@angular/cdk/drag-drop";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { DuplicateMultipleTimesModalComponent } from './components/duplicate-multiple-times-modal/duplicate-multiple-times-modal.component';
import {A11yModule} from "@angular/cdk/a11y";
import {NgSelectModule} from "@ng-select/ng-select";
import { SelectChecklistTypeComponent } from './components/select-checklist-type/select-checklist-type.component';
import { ChecklistCheckpointComponent } from './checklist/checklist-checkpoint/checklist-checkpoint.component';
import { ChecklistNodeComponent } from './checklist/checklist-node/checklist-node.component';
import {
    SelectExistingCheckpointModalComponent
} from "./components/select-existing-checkpoint-modal/select-existing-checkpoint-modal.component";
import {
    ChangeChecklistTypeModal
} from "./components/change-checklist-type-modal/change-checklist-type-modal.component";
import {TreeModule} from '@ali-hm/angular-tree-component';
import {MatSnackBarModule} from '@angular/material/snack-bar';

@NgModule({
    imports: [
        CommonModule,
        CommonsModule,
        TranslateModule.forChild(),
        ReactiveFormsModule,
        MDBBootstrapModulesPro,
        ChappsListModule,
        ChappsCommonAngularLibraryModule,
        TreeModule,
        FormsModule,
        MatSnackBarModule,
        DragDropModule,
        A11yModule,
        NgSelectModule,
    ],
    providers: [],
    exports: [
        SelectChecklistTypeComponent,
    ],
    declarations: [
        ChecklistsComponent,
        ChecklistComponent,
        ChecklistListItemComponent,
        CreateChecklistModalComponent,
        AddNodeOrCheckpointModalComponent,
        AddCustomCheckpointModalComponent,
        EditNodeModalComponent,
        RenameChecklistModal,
        CopyChecklistModalComponent,
        SelectCheckpointCreationMethodModal,
        AddUpdateCheckpointModalComponent,
        DuplicateMultipleTimesModalComponent,
        SelectChecklistTypeComponent,
        ChecklistCheckpointComponent,
        ChecklistNodeComponent,
        SelectExistingCheckpointModalComponent,
        ChangeChecklistTypeModal,
    ],
})
export class ChecklistsModule { }
